import Input from './Input';

export default function Textarea({ noMarginTop = false, labelProps, rows = 3, ...props }) {
  return (
    <Input
      {...props}
      as='textarea'
      rows={rows}
      labelProps={{
        ...labelProps,
        className: `${noMarginTop ? '' : 'mt-3'} ${labelProps?.className || ''}`,
      }}
    />
  );
}
